<template>
    <vertical-table v-bind="{ items }" />
</template>

<script>
import { mapState } from "vuex";
import { initExpoProgram } from "@/assets/variables/inits";

import VerticalTable from "@/components/dumb/vertical-table.vue";

export default {
    components: {
        VerticalTable,
    },
    props: {
        program: { type: Object, default: initExpoProgram },
    },
    computed: {
        ...mapState("ui", { innerWidth: (store) => store.window.innerWidth }),
        items() {
            const breakpoint = this.innerWidth < 1200;
            const cols = breakpoint ? undefined : 6;
            const headerProps = {
                style: breakpoint ? "width: 160px" : "width: 100px",
            };
            return [
                {
                    term: "프로그램 진행기간",
                    data: this.program.date.programDisplay.text,
                    order: 1,
                    orderLg: 1,
                    headerProps: { style: "width: 160px" },
                },
                {
                    term: "기업회원 접수기간",
                    data: this.program.date.employerSubmit.text,
                    cols,
                    order: 2,
                    orderLg: 2,
                    headerProps: { style: "width: 160px" },
                },
                {
                    term: "매칭기간",
                    data: this.program.date.matchingSubmit.text,
                    cols,
                    order: 4,
                    orderLg: 3,
                    headerProps,
                },
                {
                    term: "개인회원 접수기간",
                    data: this.program.date.employeeSubmit.text,
                    cols,
                    order: 3,
                    orderLg: 4,
                    headerProps: { style: "width: 160px" },
                },
                {
                    term: "면접기간",
                    data: this.program.date.interviewSpans.text,
                    cols,
                    order: 5,
                    orderLg: 5,
                    headerProps,
                },
            ];
        },
    },
};
</script>

<style>
</style>